import { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { Text } from 'roo-ui/components';
import uniqueId from 'lodash/uniqueId';
import { TitleBar, CloseButton, BodyWrapper } from './primitives';
import PopoverModal from './PopoverModal';

const MobileContentWrapper = ({ title, children, onClose, ...reactModalProps }) => {
  const id = useRef(uniqueId(`PopoverModal_`)).current;
  const aria = useMemo(
    () => ({
      labelledby: `${id}_labelled_by`,
      describedby: `${id}_described_by`,
    }),
    [id],
  );

  return (
    <PopoverModal contentLabel={title} aria={aria} onRequestClose={onClose} {...reactModalProps}>
      <TitleBar>
        <Text fontSize="lg" id={aria.labelledby}>
          {title}
        </Text>
        <CloseButton onClick={onClose} />
      </TitleBar>
      <BodyWrapper id={aria.describedby}>{children}</BodyWrapper>
    </PopoverModal>
  );
};

MobileContentWrapper.propTypes = {
  ...ReactModal.propTypes,
  title: PropTypes.string,
};

export default MobileContentWrapper;
